import React, { Component } from 'react';
import { Button, Card, CardHeader, CardBody, CardFooter, Col, Container, Form, FormGroup, Label, Input, InputGroup, InputGroupAddon, InputGroupText, Row, NavLink } from 'reactstrap';

import Api from '../../api'

class crNote extends Component {
  
  render() {
    return (
      <div className="rcnote mt-5">
        &copy; Copyright {(new Date().getFullYear())} by AskMyPhone. All Rights Reserved.
        <span>AVMS. v0.01.181230</span>
      </div>
    )
  }
}

export default crNote;


// WEBPACK FOOTER //
// ./src/views/Common/crNote.js